module.exports = __webpack_public_path__ + "assets/img/陈军-code.56802f0c.jpg";